import React, { Fragment, useEffect, useState } from "react";
// import DualListBox from "../../core/BaseComponents/CustomDualList/DualListBox";
import BasicModal from "../../core/BaseComponents/Modal";
import RailConfigPreview from "./RailConfigPreview";
import { Switch, Tooltip } from "@mui/material";

function Utility(props) {
  const { tabChangeHandler, tabs, masterHotelChannelList, onSubmitHandler, editPublishUnPublish,
          railName, roomTypes, selectedChannelForYouFullObject, onResetHandler, selectedHotelChannelFullObject,
          selectedPartnerFullObject, selectedHotelServiceFullObject,setSelectedHotelChannelFullObject, onResetHotelChannel, defaultValue, setHotelChannelData, setPayloadHotelChannel,setShowUtility, showUtility } = props;

  const [preview, setPreview] = useState(false);
  const [initialSelected, setInitialSelected] = useState([]);
  const [hotelChannelList, setHotelChannelList] = useState([])

  const [selectedHotelChannel, setSelectedHotelChannel] = useState([]);
  const [previewHotelChannel, setPreviewHotelChannel] = useState([])

  useEffect(() => {
    if (Array.isArray(defaultValue) && defaultValue.length) {
      const defaultSids = defaultValue.map((item) => item.utilityId);
      const defaultHotelsChannel = masterHotelChannelList?.filter((HotelsChannelData) =>defaultSids.includes(HotelsChannelData?.id))
      const sequenceData = defaultHotelsChannel?.map((HotelsChannel)=>({...HotelsChannel, sequenceNo: defaultValue?.find(def=>def?.utilityId === HotelsChannel?.id)?.sequenceNo}))
      const sortedData = sequenceData?.sort((a,b)=>a.sequenceNo - b.sequenceNo)
      setSelectedHotelChannelFullObject(sortedData)
      setPreviewHotelChannel(sortedData)
      setInitialSelected(sortedData);
      setHotelChannelList(
        masterHotelChannelList?.filter(
          (partnerData) => !defaultSids.includes(partnerData?.id)
        )
      );
      // setSelectedPartners({partnerIds: defaultSids})
    } else {
      setHotelChannelList(masterHotelChannelList);
      setSelectedHotelChannelFullObject([])
      setSelectedHotelChannel([])
      setPreviewHotelChannel([])
      setInitialSelected([]);
    }
  }, [defaultValue, masterHotelChannelList]);

  useEffect(() => {
    if (defaultValue?.length) {
      // localStorage.setItem(
      //   "hotelChannelPayload",
      //   JSON.stringify({ hotelChannelSequence: defaultValue })
      // );
      setPayloadHotelChannel({ utility: defaultValue })
      setSelectedHotelChannel(defaultValue)
    }
  }, [defaultValue])

  // const handleItemsChange = (selected) => {
  //   setSelectedHotelChannelFullObject(selected)
  //   const data = selected?.map((data,index) => ({utilityId:data.id, sequenceNo:index+1}))
  //   setPreviewHotelChannel(selected)
  //   setSelectedHotelChannel(data)
  // };

  const previewHandler = () => {
    // localStorage.setItem(
    //   "hotelChannelPayload",
    //   JSON.stringify({ hotelChannelSequence: selectedHotelChannel })
    // );
    setPayloadHotelChannel({ utility: selectedHotelChannel })
    setHotelChannelData(selectedHotelChannel)
    setPreview(true);
  }

  const onSaveHandler = () => {
    // localStorage.setItem(
    //   "hotelChannelPayload",
    //   JSON.stringify({ hotelChannelSequence: selectedHotelChannel })
    // );
    setPayloadHotelChannel({ utility: selectedHotelChannel })
    setHotelChannelData(selectedHotelChannel)
    const nextTab = tabs?.find((data)=>data?.railName==="utility")
    if(nextTab?.sequenceNo<5){
      tabChangeHandler(nextTab?.sequenceNo)
    }
    else{
      setPreview(true);
    }
  }

  return (
    <Fragment>
      {/* <DualListBox
        listTitle="List Of Utilities"
        selectedListTitle="Selected Utilities"
        items={hotelChannelList}
        initialData={initialSelected}
        onChange={(selected) => handleItemsChange(selected)}
      /> */}
      <div className="col-6 d-flex align-items-center">
      <Tooltip title={showUtility ? "Active" : "Inactive"} arrow>
        <Switch
          name="active"
          onChange={(event) => {setShowUtility(event.target.checked);console.log(event.target.checked)}}
          inputProps={{ "aria-label": "controlled" }}
          value={showUtility}
          checked={showUtility}
          className={`${showUtility === false ? 'switchuser-inactive' : 'switchuser-active'}`}
        />
      </Tooltip>
      <div className="auto-mode">
        <span className={`${showUtility ? "automode-enabled" : "automode-disabled"}`}>{`${showUtility ? "Enabled" : "Disabled"}`}</span>
        </div>
      </div>
      <div className="text-end">
        {editPublishUnPublish && <button
          onClick={onResetHotelChannel}
          type="button"
          className="create-btn ms-2"
        >
          Reset
        </button>}
        <button
          onClick={previewHandler}
          type="button"
          className="create-btn ms-2"
        >
          preview
        </button>
        <button
          onClick={onSaveHandler}
          type="button"
          className="create-btn ms-2"
        >
          {editPublishUnPublish ? "Update" : "Save"}
        </button>
      </div>
      {preview && (
        <BasicModal
          popupOpen={preview}
          bodyMessage={
            <RailConfigPreview
              setPreview={setPreview}
              // onSubmitHandler={onSubmitHandler}
              // editPublishUnPublish={editPublishUnPublish}
              previewListRowData={{ roomTypes, railName }}
              onCreateRailConfigPreview={true}
              tabs={tabs}
              showUtility={showUtility}
              onResetHandler={onResetHandler}
              previewUtilityData={previewHotelChannel}
              previewPartnerData={selectedPartnerFullObject}
              previewChannelData={selectedChannelForYouFullObject}
              previewHotelServiceData={selectedHotelServiceFullObject}
              previewHotelChannelData={selectedHotelChannelFullObject}
            />
          }
          popupSize={"col-11 rails-preview"}
          footer={{
            ...(editPublishUnPublish && {
              thirdButton: {
                buttonName: "Reset Rail",
                action: () => onResetHandler(),
              },
            }),
            primaryButton: {
              buttonName: `${editPublishUnPublish ? "Update" : "Create"} Rail`,
              action: () => onSubmitHandler(false),
            },
            secondaryButton: {
              buttonName: "Publish Rail",
              action: () => onSubmitHandler(true),
            },
          }}
          popBtnAlignment="justify-content-end"
        />
      )}
    </Fragment>
  );
}

export default Utility;
